"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = __importDefault(require("classnames"));
const form_1 = require("components/form");
const input_1 = require("components/input");
const loader_1 = require("components/loader");
const translate_1 = require("components/translate");
const constants_1 = require("configs/routes/constants");
const Survicate_1 = require("configs/Survicate");
const useModal_1 = require("hooks/useModal");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const class_1 = require("modules/app/services/datahub/class");
const ClassReferrerUtil_1 = __importDefault(require("modules/classManager/ClassReferrerUtil"));
const ClassService_1 = __importDefault(require("modules/classManager/ClassService"));
const constants_2 = require("modules/classManager/constants");
const DefaultClassUtil_1 = __importDefault(require("modules/classManager/DefaultClassUtil"));
const ContentBasePage_1 = __importDefault(require("modules/content/components/ContentBasePage"));
const featureToggle_1 = require("modules/featureToggle");
const helpers_1 = require("modules/onlineEvent/helpers");
const CreatedClassMessage_1 = __importDefault(require("./CreatedClassMessage"));
const defaultClassToggle_1 = require("./defaultClassToggle");
const deleteClassButton_1 = require("./deleteClassButton");
const offers_1 = require("./offers");
require("./ClassContent.scss");
const ClassContent = ({ classId, isAddClassModuleFeatureEnabled, t }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { offers, initialSelectedOffers } = (0, offers_1.useOffer)({ classId });
    const { isModalOpen, handleOpen: handleOpenModal } = (0, useModal_1.useModal)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [id, setId] = (0, react_1.useState)();
    const [name, setName] = (0, react_1.useState)('');
    const [isDefaultClass, setIsDefaultClass] = (0, react_1.useState)(false);
    const [defaultClassToggleTrue, setDefaultClassToggleTrue] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            if (classId) {
                const currentClass = await ClassService_1.default.getClassById(classId);
                if (currentClass) {
                    const { id, name, defaultClass } = currentClass;
                    setId(id);
                    setName(DefaultClassUtil_1.default.getName(name));
                    setIsDefaultClass(defaultClass);
                    setDefaultClassToggleTrue(defaultClass);
                }
            }
            setIsLoading(false);
        };
        fetchData();
    }, [classId]);
    const redirectToClassListPage = () => history.push(constants_1.ROUTES.CLASS.LIST);
    const handleChangeDefaultClassToggle = () => {
        if (!isDefaultClass) {
            setDefaultClassToggleTrue((prevState) => !prevState);
        }
    };
    const handleSubmit = async (formData) => {
        setIsLoading(true);
        let createdClassId = void 0;
        if (formData) {
            if (id) {
                await ClassService_1.default.updateClass(id, formData, defaultClassToggleTrue);
            }
            else {
                createdClassId = await ClassService_1.default.createClass(formData, defaultClassToggleTrue);
            }
            class_1.DatahubClassService.sendSaveClassEvent({
                isNew: !id,
                newClassReferrer: ClassReferrerUtil_1.default.getValue()
            });
            ClassReferrerUtil_1.default.clearValue();
            (0, Survicate_1.showSurvey)(Survicate_1.SURVEY_ID_LIST.CLASSES);
        }
        setIsLoading(false);
        if (isAddClassModuleFeatureEnabled && createdClassId) {
            setId(createdClassId);
            handleOpenModal();
        }
        else {
            redirectToClassListPage();
        }
    };
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(loader_1.Loader, { style: { position: 'initial' } });
    }
    const contentBasePageClasses = (0, classnames_1.default)({
        'class__content--no-padding': classId,
        'content__grid': !classId
    });
    const inputGroupProps = {
        name: 'name',
        required: true,
        value: name,
        maxLength: 100,
        autoComplete: 'off',
        placeholder: (0, helpers_1.onlineEventLabelHandler)('class_manager.class_editor.class_name')
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(form_1.Form, { onSubmit: handleSubmit, children: (0, jsx_runtime_1.jsxs)(ContentBasePage_1.default, { className: contentBasePageClasses, backHandler: redirectToClassListPage, children: [!classId && ((0, jsx_runtime_1.jsx)(ContentBasePage_1.default.Header, { title: t(constants_2.CLASS_FORM_TITLE.NEW, { checkOnlineEvent: true }), isTitleLabel: false })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "_mb-5", children: [(0, jsx_runtime_1.jsx)("label", { className: "hot-form__label _text-2 _font-weight-bold _text-gray-900", htmlFor: "name", children: t('general.name') }), (0, jsx_runtime_1.jsx)(form_1.FormControl, { children: (0, jsx_runtime_1.jsx)(input_1.InputGroup, { ...inputGroupProps }) })] }), (0, jsx_runtime_1.jsx)(defaultClassToggle_1.DefaultClassToggle, { classId: classId, isDefaultClass: isDefaultClass, isChecked: defaultClassToggleTrue, onChange: handleChangeDefaultClassToggle }), (0, jsx_runtime_1.jsx)(form_1.FormControl, { children: (0, jsx_runtime_1.jsx)(offers_1.Offers, { className: "_my-5", classId: classId, name: "offersCheckList", value: initialSelectedOffers, items: offers }) }), classId && !isDefaultClass && ((0, jsx_runtime_1.jsx)(deleteClassButton_1.DeleteClassButton, { classId: classId, onDelete: redirectToClassListPage }))] }), !isLoading && (0, jsx_runtime_1.jsx)(ContentBasePage_1.default.Footer, {})] }) }), isModalOpen && id && (0, jsx_runtime_1.jsx)(CreatedClassMessage_1.default, { classId: id })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)(({ FeatureToggleStore }) => {
    var _a;
    return ({
        isAddClassModuleFeatureEnabled: (_a = FeatureToggleStore === null || FeatureToggleStore === void 0 ? void 0 : FeatureToggleStore.featureToggles) === null || _a === void 0 ? void 0 : _a.get(featureToggle_1.FeatureToggles.AddClassModules)
    });
}))(ClassContent);
